import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { request } from 'graphql-request';
import uuidv1 from 'uuid/v1';
import { mobileCheck } from '~/utils/utils';
import SiteSettings from '~/siteSettings';


// GQL
import GET_VIDEO_EMBED from '~/graphql/GET_VIDEO_EMBED.graphql';

const CmvAvia = dynamic(() => import('@cbsi-ctd/cmv_avia').then((mod) => mod.Player), { ssr: false });

function AmpVideoEmbed(props) {
  const { video, pageType, siteSection, keywords } = props;

  useEffect(() => {
    // Create a Surrogate Utag Object for Ad Calls
    window.utag_data = {
      keywords,
      pageType,
      pageViewGuid: uuidv1(),
      siteSection
    };
  });

  if(video) {
    const metadata = {
      brandPlatformId: mobileCheck() ? 'drewbarrymore_site_mweb' : 'drewbarrymore_site_desktop',
      duration:  video.duration,
      authorName: 'The Drew Barrymore Show Staff',
      contentBrand: SiteSettings.siteName,
      siteCode: SiteSettings.brand,
      siteType: 'google_amp',
      videoTitle: video.title,
      vidPlayerPos: 'hero',
    }


    return(
      <>
        <Head>
          <script async src="https://cdn.ampproject.org/video-iframe-integration-v0.js"></script>
          <script dangerouslySetInnerHTML={{__html: `
            (window.AmpVideoIframe = window.AmpVideoIframe || []).push(
              onAmpIntegrationReady
            );
          
            function onAmpIntegrationReady(ampIntegration) {
              ampIntegration.postEvent('canplay');
            }
          `}}></script>
        </Head>
        <CmvAvia
          amp
          autoplay='attemptUnmutedThenMuted'
          compactViewBreakpoint={480}
          continuousPlay={0}
          embedded={true}
          disableTracking
          enableOm
          hideAds={true}
          keywords={video.keywords}
          posterImageUrl={video.thumbnails?.[0].streamingUrl}
          mediaUrl={video.hls_streaming_url}
          metadata={metadata}
          captions={ video?.field_video_captions
            ? `/vtt?file=${ video.field_video_captions}`
            : null
          }
          siteSettings={SiteSettings}
          useUnmuteCta
        />
      </>
    );
  }

  return(
    <div className='msg msg--dark'>
      No video defined.
    </div>
  );
}

export async function getServerSideProps(ctx) {
  // Get Data
  let video = '';
  if(!ctx?.query?.sVid) {
    const nodeQuery = await request(process.env.NEXT_PUBLIC_API_HOST || 'https://api-stage.thedrewbarrymoreshow.com/cmv_graphql/api/query', GET_VIDEO_EMBED, {
      target_id: parseInt(ctx?.query?.vid, 10),
    });
    if(nodeQuery?.nodeQuery?.field_video_mpx_id) {
      video = {
        ...nodeQuery?.nodeQuery?.field_video_mpx_id,
        field_video_captions: nodeQuery?.nodeQuery?.field_video_captions?.path || ''
      };
    }
  } else {
    video = JSON.parse(ctx?.query?.sVid);
  }

  return {
    props: {
      video,
      pageType: ctx?.query?.pageType || '',
      siteSection: ctx?.query?.siteSection || '',
      keywords: ctx?.query?.kw || ''
    }
  }
}

export default AmpVideoEmbed
